(function () {
  function activate(root, tab, persist) {
    if (!root || !tab) return;
    var id = tab.getAttribute('data-rof-sc-tab');
    var tabs = root.querySelectorAll('[data-rof-sc-tab]');
    var panels = root.querySelectorAll('[data-rof-sc-panel]');
    tabs.forEach(function (t) {
      var on = t === tab;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
    });
    panels.forEach(function (panel) {
      var on = panel.getAttribute('data-rof-sc-panel') === id;
      panel.classList.toggle('is-active', on);
      if (on) {
        panel.removeAttribute('hidden');
        var img = panel.querySelector('img');
        if (img && !img.complete) {
          img.loading = 'eager';
        }
      } else {
        panel.setAttribute('hidden', '');
      }
    });
    if (persist && id && history.replaceState) {
      history.replaceState(null, '', '#' + id);
    }
  }

  function tabById(root, id) {
    if (!id) return null;
    return root.querySelector('[data-rof-sc-tab="' + id + '"]');
  }

  function startTab(root) {
    if (!root) return;
    var hash = (location.hash || '').replace('#', '');
    var aliases = { hoodie: 'hood', crew: 'sweat', tee: 't-shirt', tshirt: 't-shirt' };
    if (aliases[hash]) hash = aliases[hash];
    var tab = tabById(root, hash) || tabById(root, root.getAttribute('data-rof-sc-start'));
    if (!tab) tab = root.querySelector('[data-rof-sc-tab]');
    if (tab) activate(root, tab, false);
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-rof-sc]').forEach(function (root) {
      if (root.getAttribute('data-rof-sc-booted') === '1') return;
      root.setAttribute('data-rof-sc-booted', '1');
      startTab(root);
    });
  }

  document.addEventListener('click', function (event) {
    var tab = event.target.closest('[data-rof-sc-tab]');
    if (!tab) return;
    var root = tab.closest('[data-rof-sc]');
    if (!root) return;
    event.preventDefault();
    activate(root, tab, true);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
    var tab = event.target.closest('[data-rof-sc-tab]');
    if (!tab) return;
    var root = tab.closest('[data-rof-sc]');
    if (!root) return;
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-rof-sc-tab]'));
    var i = tabs.indexOf(tab);
    if (i < 0) return;
    var next = event.key === 'ArrowRight' ? (i + 1) % tabs.length : (i - 1 + tabs.length) % tabs.length;
    event.preventDefault();
    tabs[next].focus();
    activate(root, tabs[next], true);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) boot(event.target);
  });
})();
